
















































































































































































import {
  defineComponent, reactive, ref, Ref, onMounted, watch, computed,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getStockLocations,
  updatePurchaseOrderFill,
  getPurchaseOrder,
  getPurchaseOrderItems,
  getPurchaseOrderMiscItems,
  searchPurchaseOrderItems,
  getSuppliers,
} from '@/api/index';

import purchaseOrderItems from '@/table/PurchaseOrder/receive-item';
import purchaseOrderMiscItems from '@/table/PurchaseOrder/receive-misc-item';
import purchaseOrderItemWithAmountTableOption from '@/table/PurchaseOrder/receive-item-with-amount';
import purchaseOrderMiscItemWithAmountTableOption from '@/table/PurchaseOrder/receive-misc-item-with-amount';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import usePurchaseOrder from '@/use/usePurchaseOrder';

const NOW = useFormat.date().computerShortDate();

const Receive = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
  },
  props: {
    edit: { default: false },
    title: { default: '' },
  },
  setup(props) {
    const { route, router } = useRouter();
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const { statusClassMap, statusTranslate } = usePurchaseOrder();
    const getStockLocationsResult = (data: any) => data.data.data;
    const step = ref(1);
    const refetchQuery = ref(false);
    const confirmModal = ref(null);
    const purchaseOrder = ref({
      id: -1,
      type: 'MATERIALS',
      supplier: { name: '', taxId: '', address: {} },
      invoice: '',
    });
    const getSuppliersResult = (data: any) => data.data.data;
    const purchaseOrderTableData = ref({ total: 0, data: [] });
    const forceRender = ref(false);
    const form = reactive({
      type: '',
      status: 'PENDING',
      invoice: '',
      items: [],
      miscItems: [],
      remarks: '',
      call: async () => {
        if (props.edit) console.log('TO DO');
        else {
          await updatePurchaseOrderFill(purchaseOrder.value.id, computedFillInput.value as any);
        }
        (confirmModal.value as any).compose({ action: 'รับของ' });
      },
      state: {
        value: 'READY',
      },
    });
    const computedFillInput = computed(() => {
      if (purchaseOrder.value.type === 'MATERIALS') {
        return {
          items: form.items.map((item: any) => ({
            purchaseOrderItemId: item.id,
            stockLocationId: item.stockLocation.id,
            amount: item.addedAmount,
          })),
          invoice: form.invoice,
          remarks: form.remarks,
        };
      }
      return {
        items: form.miscItems.map((item: any) => ({
          purchaseOrderMiscItemId: item.id,
          amount: item.addedAmount,
        })),
        invoice: form.invoice,
        remarks: form.remarks,
      };
    });

    const filter = computed(() => ({
      filterPoId: route.value.params.poId,
    }));

    async function getPurchaseOrderQuery() {
      purchaseOrder.value = (await getPurchaseOrder(route.value.params.poId)).data;
      if (purchaseOrder.value.invoice !== '') {
        form.invoice = purchaseOrder.value.invoice;
      }
    }
    onMounted(async () => {
      await getPurchaseOrderQuery();
      await handleInstanceSearchQuery();
    });
    const computedTableInformation = computed(() => {
      if (purchaseOrder.value.type === 'MATERIALS') {
        return {
          type: 'purchase_order_items',
          query: getPurchaseOrderItems,
          option: purchaseOrderItems,
          data: form.items,
          amountTable: purchaseOrderItemWithAmountTableOption,
        };
      }
      return {
        type: 'purchase_order_misc_items',
        query: getPurchaseOrderMiscItems,
        option: purchaseOrderMiscItems,
        data: form.miscItems,
        amountTable: purchaseOrderMiscItemWithAmountTableOption,
      };
    });

    const computedSupplierAddress = computed(() => {
      if (!(purchaseOrder.value.supplier) || !(purchaseOrder.value.supplier as any).province_id) return '';
      if (!(purchaseOrder.value.supplier as any).district_id) return '';
      if (!(purchaseOrder.value.supplier as any).subdistrict_id) return '';
      const key = (purchaseOrder.value.supplier as any)?.show_as_english ? 'name_in_english' : 'name_in_thai';
      const subDistrict = (purchaseOrder.value.supplier as any).sub_district[key] !== 'NULL' ? (purchaseOrder.value.supplier as any).sub_district[key] : (purchaseOrder.value.supplier as any).sub_district.name_in_thai;
      return `${(purchaseOrder.value.supplier as any).address}${key === 'name_in_english' && (purchaseOrder.value.supplier as any).province_id !== 1 ? ' Tumbol ' : ' '}${subDistrict} ${(purchaseOrder.value.supplier as any).district[key]} ${(purchaseOrder.value.supplier as any).province[key]} ${(purchaseOrder.value.supplier as any).zipcode}`;
    });

    // Use to store which item already select
    const selectedItemId: Ref<number[]> = ref([]);
    // Use to finallize value that send to search api (Search api for find whole item that user choose to create PR)
    const searchValue: Ref<string | number[] | null> = ref(null);
    // Use to select item;
    function selectItem(id: number) {
      const hitIndex = selectedItemId.value.indexOf(id);
      if (selectedItemId.value.indexOf(id) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(id);
      if (selectedItemId.value.length !== purchaseOrderTableData.value.total) searchValue.value = selectedItemId.value;
      else searchValue.value = 'ALL';
    }
    function clearSelect() {
      selectedItemId.value = [];
      searchValue.value = [];
    }
    function selectAll() {
      forceRender.value = true;
      selectedItemId.value = purchaseOrderTableData.value.data.map((subJob: any) => subJob.id);
      searchValue.value = 'ALL';
      forceRender.value = false;
    }

    // Watch when route change;
    watch(() => route.value.params.poId, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        await getPurchaseOrderQuery();
        step.value = 1;
        clearSelect();
        refetchQuery.value = true;
      }
    });

    // use this to manually paginate create pr page;
    const page = ref(1);
    const PERPAGE = 6;
    const receivePurchaseOrderPaginator = computed(() => ({
      perPage: PERPAGE,
      total: form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length === 0 ? 1 : Math.ceil(form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length / PERPAGE),
      totalPages: form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length === 0 ? 1 : Math.ceil(form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length / PERPAGE),
    }));
    async function forward() {
      const result = await searchPurchaseOrderItems({ ids: searchValue.value, purchaseOrderId: route.value.params.poId }, computedTableInformation.value.type);
      if (purchaseOrder.value.type === 'MATERIALS') {
        form.items = result.filter(((item: any) => item.filled_amount < item.amount)).map((item: any) => ({
          id: item.id,
          amount: parseFloat(item.amount).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          filledAmount: parseFloat(item.filled_amount).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          addedAmount: parseFloat(`${item.amount - item.filled_amount}`).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          bom_item: item.bom_item,
          material: item.material,
          stockLocation: null as any,
          target_date: item.target_date,
          created_at: item.created_at,
        }));
      } else {
        form.miscItems = result.filter(((item: any) => item.filled_amount < item.amount)).map((item: any) => ({
          id: item.id,
          amount: parseFloat(item.amount).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          filledAmount: parseFloat(item.filled_amount).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          addedAmount: parseFloat(`${item.amount - item.filled_amount}`).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          description: item.description,
          stockLocation: null as any,
          unit: item.unit,
          target_date: item.target_date,
          created_at: item.created_at,
        }));
      }
      step.value = 2;
    }
    async function backward() {
      step.value = 1;
    }
    const displayData = computed(() => {
      if ((computedTableInformation.value.data as any).length < receivePurchaseOrderPaginator.value.to) return (computedTableInformation.value.data as any).slice(receivePurchaseOrderPaginator.value.from, (computedTableInformation.value.data as any).length);
      return (computedTableInformation.value.data as any).slice(receivePurchaseOrderPaginator.value.from, receivePurchaseOrderPaginator.value.to);
    });

    // Hook when CommonRichTableWithAxios finish fetching data;
    // use this to check total record & how many user has select item.
    function receivePurchaseOrderData(data: any) {
      purchaseOrderTableData.value = {
        data: data.data,
        total: data.total,
      };
    }

    // Handle "instantSearch" if redirect from PanelWithPurchaseOrderItemTable component
    async function handleInstanceSearchQuery() {
      if (route.value.query.instantSearch) {
        if (route.value.query.instantSearch === 'string' && route.value.query.instantSearch !== 'ALL') {
          selectedItemId.value = [parseInt(route.value.query.instantSearch, 10)];
          searchValue.value = [parseInt(route.value.query.instantSearch, 10)];
        } else if (!Array.isArray(route.value.query.instantSearch)) {
          selectedItemId.value = [route.value.query.instantSearch];
          searchValue.value = [route.value.query.instantSearch];
        } else {
          selectedItemId.value = route.value.query.instantSearch;
          searchValue.value = route.value.query.instantSearch;
        }
        await forward();
      }
    }

    function updateStockLocation($event: any, index: number) {
      const payload = purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems';
      const { perPage } = receivePurchaseOrderPaginator.value;
      if (perPage) {
        (form[payload][(perPage) ? ((page.value - 1) * perPage) + index : index] as any).stockLocation = $event as any;
      }
    }

    return {
      NOW,
      toDate,

      getSuppliers,
      getSuppliersResult,

      purchaseOrder,
      forceRender,
      confirmModal,
      step,
      forward,
      backward,

      filter,
      computedTableInformation,
      refetchQuery,
      selectItem,
      selectedItemId,
      searchValue,

      clearSelect,
      selectAll,
      form,

      displayData,
      page,
      pagination: receivePurchaseOrderPaginator,

      purchaseOrderTableData,
      receivePurchaseOrderData,

      computedSupplierAddress,

      getStockLocations,
      getStockLocationsResult,

      statusClassMap,
      statusTranslate,

      updateStockLocation,
    };
  },
});

export default Receive;
